
export const APIvar = {

    address: "",

    forgotPass: "",

    colorUse: '#B000AF',

    colorSecondary: '#007fff',

    colorTerciary: 'white',

    colorBackground: 'linear-gradient(135deg, #ffccff 0%, #B000AF 100%)',

    cardBackgrounColor: '#ffccff',

    colorLines: 'gray',

    colorTouchableFont: 'white',
    colorTouchable: 'red',

    listColor: 'white',

    appVersion: "1.0",

    listHeight: '15%',

    fontLarge: '2.5%',

    fontSmall: '2%',

    fontList: '2.2%',
    fontListSmall: '1.8%',

    paddList: '2%',
    paddTouchable: '1%',

    sectionHeaderPaddingVertical: '0.5%',
    sectionHeaderPaddingHorizontal: '2%',

    heightTouchable: '5%',
    iconModal: '3%',
    iconModalLarge: '5%',

    heightTouchModal: '4.5%',

    formRowGap: '7px'
};
